import { useEffect, useState } from "react";
import { Nav } from "../components/Nav";
import { Footer } from "../components/Footer";
import { Hero } from "../components/home/Hero";
import { StatsStrip, Realms, SessionSettings, Pricing, Credentials, Privacy, FrescoBand, Marriage, MerchBand } from "../components/home/Sections";
import { Testimonials } from "../components/home/Testimonials";
import { Enquiry, Partners } from "../components/home/EnquiryPartners";
import { api } from "../lib/api";
import { Seo } from "../components/Seo";

export default function Landing() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="landing-page">
      <Seo
        title="No BS Counselling — Straight-Talk Counselling on the Coast"
        description="Forty years of straight-talk counselling for men, couples and families on the Coast. Marriage, trauma, grief — no judgement, no shrink speak. Book a session."
      />
      <Nav />
      <Hero />
      <Marriage />
      <FrescoBand />
      <StatsStrip />
      <Realms />
      <SessionSettings />
      <Pricing />
      <MerchBand />
      <Credentials />
      <Testimonials />
      <Enquiry />
      <Partners />
      <Privacy />
      <Footer config={config} />
    </div>
  );
}
